import React, { memo, useState } from "react";
import { imageBasePath } from "../../../Utils/config";

const MembershipOrder = ({
  location,
  massageCardsData,
  performanceData,
  bodyTransformationData,
  cuppingTherapyData,
  advancedElectroMuscularData,
  manipulativeTherapyData,
  physiotherapyData,
  acupunctureData,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const cartWidth = isOpen ? "w-[273px]" : "w-[50px] sm:w-[80px]";

  let summary = [];
  if (!!location) {
    summary = [
      ...summary,
      {
        name: `Treatment Location (${location?.name})`,
        price: location?.price,
      },
    ];
  }
  if (!!massageCardsData?.length) {
    summary = [
      ...summary,
      {
        name: "Massage Therapy",
        price:
          massageCardsData?.reduce((prev, { charge }) => prev + charge, 0) || 0,
      },
    ];
  }
  if (!!physiotherapyData?.length) {
    summary = [
      ...summary,
      {
        name: "Physiotherapy",
        price:
          physiotherapyData
            ?.filter((item) => item.isChecked)
            ?.reduce((prev, { price }) => prev + price, 0) || 0,
      },
    ];
  }
  if (!!acupunctureData?.length) {
    summary = [
      ...summary,
      {
        name: "Acupuncture",
        price:
          acupunctureData
            ?.filter((item) => item.isChecked)
            ?.reduce((prev, { price }) => prev + price, 0) || 0,
      },
    ];
  }
  if (!!performanceData?.length) {
    summary = [
      ...summary,
      {
        name: "Performance Mobility Therapy",
        price:
          performanceData
            ?.filter((item) => item.isChecked)
            ?.reduce((prev, { price }) => prev + price, 0) || 0,
      },
    ];
  }
  if (!!bodyTransformationData?.length) {
    summary = [
      ...summary,
      {
        name: "Body Transformation",
        price:
          bodyTransformationData
            ?.filter((item) => item.isChecked)
            ?.reduce((prev, { price }) => prev + price, 0) || 0,
      },
    ];
  }
  if (!!cuppingTherapyData?.length) {
    summary = [
      ...summary,
      {
        name: "Performance Mobility Therapy",
        price:
          cuppingTherapyData
            ?.filter((item) => item.isChecked)
            ?.reduce((prev, { price }) => prev + price, 0) || 0,
      },
    ];
  }
  if (!!advancedElectroMuscularData?.length) {
    summary = [
      ...summary,
      {
        name: "Advanced Electro Muscular Therapy",
        price:
          advancedElectroMuscularData
            ?.filter((item) => item.isChecked)
            ?.reduce((prev, { price }) => prev + price, 0) || 0,
      },
    ];
  }
  if (!!manipulativeTherapyData?.length) {
    summary = [
      ...summary,
      {
        name: "Manipulative Medicine",
        price:
          manipulativeTherapyData
            ?.filter((item) => item.isChecked)
            ?.reduce((prev, { price }) => prev + price, 0) || 0,
      },
    ];
  }

  return (
    <div
      className={`absolute overflow-hidden top-[150px] sm:top-[200px] right-0 h-[560px] ${cartWidth} bg-[#FFFFFF] shadow-[4px_2px_24px_#00000040] rounded-l-2xl transition-all`}
    >
      <div className="grid grid-cols-5 h-[48px] items-center justify-center border-b-2 border-solid border-b-[#D9D9D9]">
        <div
          onClick={() => setIsOpen(!isOpen)}
          className={`flex justify-center items-center cursor-pointer ${
            !isOpen && "col-span-5"
          }`}
        >
          <img
            src={imageBasePath + `${isOpen ? "cart.png" : "cartclose.png"}`}
            alt="cart"
          />
        </div>
        {isOpen && (
          <p className="col-span-4 font-font-Titillium font-semibold text-[18px] text-[#141414] leading-[27px] text-center tracking-[0.0313] uppercase">
            ORDER DETAILS
          </p>
        )}
      </div>
      <div className="h-[432px] border-b-4 border-solid border-b-[#FAAD14] pl-4 pr-2 py-2 overflow-y-auto scrollbar ">
        {isOpen ? (
          summary
            ?.filter(({ price }) => price)
            ?.map((item) => (
              <div className="grid grid-cols-5 items-center py-2" key={item}>
                <p className="col-span-3 font-font-Titillium font-normal text-[16px] leading-[21px] text-[#262626] tracking-[0.0156em]">
                  {item?.name}
                </p>
                <div></div>
                <p className="col-span-1 font-font-Titillium font-normal text-[16px] text-center leading-[21px] text-[#262626] tracking-[0.0156em]">
                  £{item?.price}
                </p>
              </div>
            ))
        ) : (
          <div className="flex flex-col items-center justify-center h-full">
            <p className="rotate-[270deg] font-font-Titillium font-semibold text-[18px] text-[#141414] leading-[27px] text-center tracking-[0.0313] uppercase w-full">
              DETAILS
            </p>
            <p className="rotate-[270deg] font-font-Titillium m-8 font-semibold text-[18px] text-[#141414] leading-[27px] text-center tracking-[0.0313] uppercase w-full">
              ORDER
            </p>
          </div>
        )}
      </div>
      <div className="h-[80px] flex justify-end pr-2">
        <div className="flex flex-col justify-center items-end">
          <p className="font-font-Titillium text-[#262626] text-end w-[48px] h-[16px] font-normal text-[16px] leading-[21px] tracking-[0.0156em]">
            Total:
          </p>
          <p className="font-font-Titillium text-[#262626] text-end h-[24px] font-semibold text-[22px] leading-[33px] tracking-[0.0094em]">
            £{summary?.reduce((prev, { price }) => prev + price, 0) || 0}
          </p>
        </div>
      </div>
    </div>
  );
};

export default memo(MembershipOrder);
